/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { forwardRef, useImperativeHandle } from 'react';

// Minimal Quill-like stub returned by getEditor()
function createQuillStub() {
  const noop = () => {};
  const quill = {
    getSelection: () => ({ index: 0, length: 0 }),
    setSelection: (_i: number, _l?: number) => {},
    getLength: () => 1,
    getFormat: () => ({}),
    format: (_k: string, _v: any) => {},
    formatText: (_i: number, _l: number, _k: string, _v: any) => {},
    removeFormat: (_i: number, _l: number) => {},
    deleteText: (_i: number, _l: number) => {},
    insertText: (_i: number, _t: string) => {},
    focus: noop,
    root:
      typeof document !== 'undefined'
        ? document.createElement('div')
        : ({} as any),
    getModule: (_name: string) => ({
      addHandler: noop,
      container:
        typeof document !== 'undefined'
          ? document.createElement('div')
          : ({} as any),
    }),
    on: (_evt: string, _cb: any) => {},
  };
  return quill;
}

const ReactQuillShim = forwardRef<any, any>(
  function ReactQuillShim(_props, ref) {
    useImperativeHandle(
      ref,
      () => ({ getEditor: () => createQuillStub() }),
      [],
    );
    return null;
  },
);

export default ReactQuillShim;
